var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedHook0)",
    d: "M7.697 7.714c2.053 0 3.343 1.329 3.729 1.989l-3.06.66l.848-.66c-1.941-1.384-4.5.364-4.5 2.186c0 1.461 1.218 2.408 1.766 2.7c-1.654-.232-2.751-1.355-2.863-1.715a3.5 3.5 0 0 1-.188-.985c0-2.049 1.701-4.175 4.268-4.175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedHook1)",
    d: "M16.303 16.286c-2.053 0-3.343-1.329-3.729-1.989l3.06-.66l-.848.66c1.941 1.384 4.5-.364 4.5-2.186c0-1.46-1.217-2.408-1.766-2.7c1.654.232 2.752 1.355 2.863 1.715c.09.291.189.647.189.986c0 2.052-1.702 4.174-4.269 4.174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedHook2)",
    d: "M6.673 14.756a3.73 3.73 0 0 1-3.086-1.543c.236 1.457 1.929 3.073 4.162 3.073c1.791 0 3.351-1.565 3.908-2.349l2.203-3.253c.412-.501 1.59-1.504 2.983-1.504s3.064 1.003 3.729 1.504c-.283-.981-1.428-2.94-3.729-2.94s-3.87 1.629-4.371 2.443c-.836 1.132-2.585 3.476-2.902 3.75c-.394.343-.771.819-2.897.819"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedHook0",
    x1: 17.733,
    x2: 15.527,
    y1: 8.457,
    y2: 17.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C6F88A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedHook1",
    x1: 12,
    x2: 15.898,
    y1: 16.286,
    y2: 7.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CD7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1BB8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD7CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedHook2",
    x1: 3.583,
    x2: 18.514,
    y1: 16.286,
    y2: 3.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADF160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#17B6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0061A0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHook);
export default __webpack_public_path__ + "static/media/hook.34b0d3a1d393d96731a698530d80e582.svg";
export { ForwardRef as ReactComponent };